// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"Spinner_spinnerWrapper__5AFop","spinner":"Spinner_spinner__bObrp","rotation":"Spinner_rotation__IkaDP"};